<template>
  <!--
    role="status" (non "alert") posé ici, sur l'ancre permanente, et non sur le message :
    une région "status" doit déjà être présente dans le DOM pour que son contenu soit
    annoncé par les lecteurs d'écran. C'est donc l'apparition du message à l'intérieur
    qui constitue le changement annoncé, poliment et sans interrompre.
  -->
  <div
    ref="ancreFocus"
    tabindex="-1"
    class="after-match-notice-ancre"
    role="status"
  >
    <div v-if="isVisible" class="alert alert-info after-match-notice">
      <span>
        Reviens le lundi matin et retrouve ici ta meilleure équipe de la journée
        et les résultats que tu aurais obtenus face à chacun de tes autres adversaires.
      </span>
      <button
        type="button"
        class="btn-close"
        aria-label="Masquer ce message"
        @click="hide"
      />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

// Clé propre à ce message plutôt qu'un drapeau générique : une annonce ultérieure
// aura la sienne et s'affichera, même pour qui a masqué celle-ci
const STORAGE_KEY = "afterMatchNoticeHidden";

// Ancre qui reste dans le DOM même une fois le message masqué, pour y renvoyer
// le focus au moment du masquage plutôt que de le laisser retomber sur <body>
const ancreFocus = ref(null);

/**
 * Renvoi vrai si le message a déjà été masqué
 * Le stockage local peut être indisponible : le message s'affiche alors, plutôt que
 * de faire tomber tout l'écran live pour une information secondaire
 * @returns {Boolean} vrai si le message a déjà été masqué
 */
const isAlreadyHidden = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const isVisible = ref(! isAlreadyHidden());

/**
 * Masque le message et retient ce choix
 * On retient d'abord le choix, puis on le reflète à l'écran : si l'écriture échoue,
 * le message reste tout de même masqué pour la visite en cours
 */
const hide = () => {
  try {
    localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // Le choix ne sera pas retenu, sans conséquence sur l'affichage courant
  }
  ancreFocus.value?.focus();
  isVisible.value = false;
};
</script>

<style lang="scss" scoped>
.after-match-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  text-align: left;
  font-size: 0.9rem;
  margin-top: 2vh;
  margin-bottom: 2vh;

  .btn-close {
    flex: 0 0 auto;
    font-size: 0.7rem;
  }
}
</style>